<template>
  <section class="ssc__hero">
    <div class="ssc__hero__intro">
      <h1
        v-if="translations.landingPage.heading"
        class="ssc__hero__intro__heading"
      >
        <a
          href="#"
          @click.prevent="onHeadingClick"
        >
          {{ translations.landingPage.heading }}
        </a>
      </h1>

      <h2
        v-if="translations.landingPage.subheadingText"
        class="ssc__hero__intro__subheading"
      >
        {{ translations.landingPage.subheadingText }}
      </h2>
    </div>

    <div class="ssc__hero__imagery">
      <div
        v-if="translations.commonSettings.generalSettings.heroImage"
        class="ssc__hero__imagery__img"
      >
        <img
          :data-srcset="`
          ${translations.commonSettings.generalSettings.heroImageExtraExtraSmall} 320w,
          ${translations.commonSettings.generalSettings.heroImage} 800w`"
          data-sizes="(max-width: 767px) 320px, 800px"
          :data-src="translations.commonSettings.generalSettings.heroImage"
          role="presentation"
          class="lazyload"
        >
      </div>

      <div
        v-if="translations.commonSettings.generalSettings.heroImage2"
        class="ssc__hero__imagery__img"
      >
        <img
          :data-srcset="`
          ${translations.commonSettings.generalSettings.heroImage2ExtraExtraSmall} 320w,
          ${translations.commonSettings.generalSettings.heroImage2} 800w`"
          data-sizes="(max-width: 767px) 320px, 800px"
          :data-src="translations.commonSettings.generalSettings.heroImage2"
          role="presentation"
          class="lazyload"
        >
      </div>

      <div
        v-if="translations.commonSettings.generalSettings.heroImage3"
        class="ssc__hero__imagery__img"
      >
        <img
          :data-srcset="`
          ${translations.commonSettings.generalSettings.heroImage3ExtraExtraSmall} 320w,
          ${translations.commonSettings.generalSettings.heroImage3} 800w`"
          data-sizes="(max-width: 767px) 320px, 800px"
          :data-src="translations.commonSettings.generalSettings.heroImage3"
          role="presentation"
          class="lazyload"
        >
      </div>

      <div
        v-if="translations.commonSettings.generalSettings.heroImage4"
        class="ssc__hero__imagery__img"
      >
        <img
          :data-srcset="`
          ${translations.commonSettings.generalSettings.heroImage4ExtraExtraSmall} 320w,
          ${translations.commonSettings.generalSettings.heroImage4} 800w`"
          data-sizes="(max-width: 767px) 320px, 800px"
          :data-src="translations.commonSettings.generalSettings.heroImage4"
          role="presentation"
          class="lazyload"
        >
      </div>
    </div>
  </section>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
  @import './style.scss';
</style>
